import AgreementContract from '../abi/AgreementContract.json';
import Agreement from '../abi/Agreement.json';

// const AgreementAddress = "0x8bB1b3C1e7AC49b3E3c099d0246d37b498c83633";
const AgreementAddress = "0xc352EC50cf2117ae8103fcd2d9E4EC6ebe46F9Ff"; 
const biconomyAddress= "0x47829D7029Ab79382213d0d60B79A647bAEcd166";
const AgreementContractAbi = AgreementContract.abi;
const AgreementAbi = Agreement.abi;

export { AgreementAddress, AgreementContractAbi, AgreementAbi ,biconomyAddress}